import styles from './klaviyo.module.scss';

const Klaviyo = ({ data }) => (
  <section id={data.anchorId} className={styles.wrapper}>
    <div className={`klaviyo-form-${data.formId} ${styles.formStyle}`} />
  </section>
);

export default Klaviyo;
